<template>
  <div class="manual-layout">
    <aside class="manual-sidebar">
      <nav>
        <ul>
          <li :class="{ active: section === 'intro' }" @click="changeSection('intro')">{{ $t('manual.introduccion.titulo') }}
          </li>
          <li :class="{ active: section === 'acceso' }" @click="changeSection('acceso')">{{ $t('manual.acceso.titulo') }}
          </li>
          <li :class="{ active: section === 'welcome' }" @click="changeSection('welcome')">{{ $t('manual.welcome.titulo') }}
          </li>
          <!-- 'Verificar' removed -->
          <!-- Puedes añadir más secciones aquí -->
        </ul>
      </nav>
    </aside>
    <main class="manual-container">
      <h1>{{ $t('manual.titulo') }}</h1>
      <section v-show="section === 'intro'">
        <h2>{{ $t('manual.introduccion.titulo') }}</h2>
        <p>{{ $t('manual.introduccion.texto') }}</p>
        <h3>{{ $t('manual.requisitos.titulo') }}</h3>
        <table class="manual-table">
          <thead>
            <tr>
              <th>{{ $t('manual.requisitos.parametro') }}</th>
              <th>{{ $t('manual.requisitos.detalle') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('manual.requisitos.url') }}</td>
              <td><a href="https://ticket.agrovin-it.com/ticketagrovin/login" target="_blank">https://ticket.agrovin-it.com/ticketagrovin/login</a></td>
            </tr>
            <tr>
              <td>{{ $t('manual.requisitos.navegadores') }}</td>
              <td>{{ $t('manual.requisitos.navegadores_detalle') }}</td>
            </tr>
            <tr>
              <td>{{ $t('manual.requisitos.dispositivos') }}</td>
              <td>{{ $t('manual.requisitos.dispositivos_detalle') }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <section v-show="section === 'acceso'">
        <h2>{{ $t('manual.acceso.titulo') }}</h2>
        <ul>
          <li>
            <h3>{{ $t('manual.acceso.iniciosesion') }}</h3>
          </li>
          <h5>{{ $t('manual.acceso.loginStepstitle') }}</h5>
          <ol>
            <li>{{ $t('manual.acceso.loginSteps1') }}</li>
            <li>{{ $t('manual.acceso.loginSteps2') }}</li>
            <li>{{ $t('manual.acceso.loginSteps3') }}</li>
          </ol>
          <div style="text-align:center; margin: 18px 0;">
            <img v-if="accesoInicioSesionImg" :src="accesoInicioSesionImg" alt="Pantalla de inicio de sesión"
              style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          </div>
          <li>
            <h3>{{ $t('manual.acceso.primerlogin') }}</h3>
          </li>

          <p>{{ $t('manual.acceso.primerlogin_texto') }}</p>
          <div class="password-requirements-block">
            <strong>{{ $t('manual.acceso.primerlogin_requisitos_titulo') }}</strong>
            <ul>
              <li>{{ $t('manual.acceso.primerlogin_requisitos1') }}</li>
              <li>{{ $t('manual.acceso.primerlogin_requisitos2') }}</li>
              <li>{{ $t('manual.acceso.primerlogin_requisitos3') }}</li>
              <li>{{ $t('manual.acceso.primerlogin_requisitos4') }}</li>
              <li>{{ $t('manual.acceso.primerlogin_requisitos5') }} " (!@#$%^&*()_+-=[ ]{}|;:,.<>?)"</li>
              <li>{{ $t('manual.acceso.primerlogin_requisitos6') }}</li>
            </ul>
            <div class="password-example">
              <div style="text-align:center; margin: 18px 0;">
                <img v-if="accesoCambioContraseniaImg" :src="accesoCambioContraseniaImg" alt="Cambio de contraseña"
                  style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
                <div v-else style="color: #c00;">Cargando imagen...</div>
                <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
              </div>

              <em>{{ $t('manual.acceso.primerlogin_ejemplo') }}</em>
            </div>
<br></br>
          <p>{{ $t('manual.acceso.primerlogin_bloqueousuario') }}</p>
<div style="text-align:center; margin: 18px 0;">
                <img v-if="accesoBloqueoUsuarioImg" :src="accesoBloqueoUsuarioImg" alt="Bloqueo de usuario"
                  style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
                <div v-else style="color: #c00;">Cargando imagen...</div>
                <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
              </div>
              <br></br>

          </div>
          <br></br>
          <li>
            <h3>{{ $t('manual.acceso.cambioidioma') }}</h3>
          </li>
          <p>{{ $t('manual.acceso.cambioidioma_texto') }}</p>
          <div style="text-align:center; margin: 18px 0;">
            <img v-if="accesoCambioIdiomaImg" :src="accesoCambioIdiomaImg" alt="Cambio de idioma"
              style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          </div>
        </ul>
      </section>
      <section v-show="section === 'welcome'">
        <h2>{{ $t('manual.welcome.titulo') }}</h2>
        <ul>
          <li>
            <h3>{{ $t('manual.welcome.pantallabienvenida') }}</h3>
          </li>
          <p v-html="$t('manual.welcome.pantallabienvenida_detalle')"></p>
          <div style="text-align:center; margin: 18px 0;">
            <img v-if="welcomeBienvenidaImg" :src="welcomeBienvenidaImg" alt="Pantalla de inicio de sesión"
              style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          </div>
          <li>
            <h3 v-html="$t('manual.welcome.addticketsteps')"></h3>
          </li>
          <p v-html="$t('manual.welcome.addticketsteps_detalle')"></p>
          <ol>
            <li v-html="$t('manual.welcome.addticketsteps1')"></li>
            <ul>
              <li v-html="$t('manual.welcome.addticketsteps1a')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1b')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1c')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1d')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1e')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1f')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1g')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1h')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1i')"></li>
              <li v-html="$t('manual.welcome.addticketsteps1j')"></li>
            </ul>
            <li v-html="$t('manual.welcome.addticketsteps2')"></li>
            <li v-html="$t('manual.welcome.addticketsteps3')"></li>
          </ol>
          <p v-html="$t('manual.welcome.addticketsteps_detalle1')"></p>
          <div style="text-align:center; margin: 18px 0;">
            <img v-if="welcomeNuevoTicketImg" :src="welcomeNuevoTicketImg" alt="Nuevo ticket"
              style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          </div>
          <p v-html="$t('manual.welcome.addticketsteps_detalle1a')"></p>
          <div style="text-align:center; margin: 18px 0;">
            <img v-if="welcomeNuevoTicket1aImg" :src="welcomeNuevoTicket1aImg" alt="Adjuntar archivo paso 1"
              style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          </div>
          <p v-html="$t('manual.welcome.addticketsteps_detalle1b')"></p>
          <div style="text-align:center; margin: 18px 0;">
            <img v-if="welcomeNuevoTicket1bImg" :src="welcomeNuevoTicket1bImg" alt="Adjuntar archivo paso 1"
              style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          </div>
          <p v-html="$t('manual.welcome.addticketsteps_detalle1c')"></p>
          <div style="text-align:center; margin: 18px 0;">
            <img v-if="welcomeNuevoTicket1cImg" :src="welcomeNuevoTicket1cImg" alt="Adjuntar archivo paso 1"
              style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          </div>
          <p v-html="$t('manual.welcome.addticketsteps_detalle2')"></p>
          <img v-if="welcomeNuevoTicketEnListadoImg" :src="welcomeNuevoTicketEnListadoImg" alt="Nuevo ticket añadido"
            style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          <p v-html="$t('manual.welcome.addticketsteps_detalle4')"></p>
          <p v-html="$t('manual.welcome.addticketsteps_detalle_correo1')"></p>
          <div style="text-align:center; margin: 18px 0;">
            <img v-if="welcomeCorreoNuevoTicketImg" :src="welcomeCorreoNuevoTicketImg"
              alt="Notificación correo nuevo ticket"
              style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
          </div>

          <ul>
            <li v-html="$t('manual.welcome.addticketsteps_detalle41a')"></li>
            <p v-html="$t('manual.welcome.addticketsteps_detalle41aa')"></p>

            <img v-if="welcomeNuevoTicketDetalle41aImg" :src="welcomeNuevoTicketDetalle41aImg" alt="Asignación tecnico"
              style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <p v-html="$t('manual.welcome.addticketsteps_detalle_correo2')"></p>
            <div style="text-align:center; margin: 18px 0;">
              <img v-if="welcomeCorreoAsignarUsuarioTicketImg" :src="welcomeCorreoAsignarUsuarioTicketImg"
                alt="Notificación correo asignar usuario ticket"
                style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
              <div v-else style="color: #c00;">Cargando imagen...</div>
              <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
            </div>

            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
            <li v-html="$t('manual.welcome.addticketsteps_detalle41b')"></li>
            <img v-if="welcomeNuevoTicketDetalle41bImg" :src="welcomeNuevoTicketDetalle41bImg" alt="Cierre Ticket"
              style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <p v-html="$t('manual.welcome.addticketsteps_detalle_correo3')"></p>
            <div style="text-align:center; margin: 18px 0;">
              <img v-if="welcomeCorreoCerrarTicketImg" :src="welcomeCorreoCerrarTicketImg"
                alt="Notificación correo cerrar ticket"
                style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
              <div v-else style="color: #c00;">Cargando imagen...</div>
              <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
            </div>




            <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
            <li v-html="$t('manual.welcome.addticketsteps_detalle41c')"></li>
            <p v-html="$t('manual.welcome.addticketsteps_detalle41ca')"></p>
            <img v-if="welcomeNuevoTicketDetalle41bImg" :src="welcomeNuevoTicketDetalle41bImg" alt="Cierre Ticket"
              style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
            <div v-else style="color: #c00;">Cargando imagen...</div>
            <p v-html="$t('manual.welcome.addticketsteps_detalle_correo4')"></p>
            <div style="text-align:center; margin: 18px 0;">
              <img v-if="welcomeCorreoReabrirTicketImg" :src="welcomeCorreoReabrirTicketImg"
                alt="Notificación correo reabrir ticket"
                style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
              <div v-else style="color: #c00;">Cargando imagen...</div>
              <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
            </div>
          </ul>
        </ul>
        <p v-html="$t('manual.welcome.addticketsteps_detalle_correo5')"></p>

        <div style="text-align:center; margin: 18px 0;">
          <img v-if="welcomeCorreoInformacionAdicionalTicketImg" :src="welcomeCorreoInformacionAdicionalTicketImg"
            alt="Notificación correo información adicional ticket"
            style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
        </div>
<p v-html="$t('manual.welcome.addticketsteps_detalle5')"></p>
        <img v-if="welcomeEditarTicketEnListadoImg" :src="welcomeEditarTicketEnListadoImg" alt="Nuevo ticket añadido"
          style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
        <div v-else style="color: #c00;">Cargando imagen...</div>
        <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>


<p v-html="$t('manual.welcome.addticketsteps_detalle6')"></p>
        <div style="text-align:center; margin: 18px 0;">
          <img v-if="welcomeEditarTicket1aImg" :src="welcomeEditarTicket1aImg"
            alt="Notificación correo información adicional ticket"
            style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
        </div>

        <div style="text-align:center; margin: 18px 0;">
          <img v-if="welcomeEditarTicket1bImg" :src="welcomeEditarTicket1bImg"
            alt="Notificación correo información adicional ticket"
            style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
        </div>
        <p v-html="$t('manual.welcome.addticketsteps_detalle7')"></p>

        <div style="text-align:center; margin: 18px 0;">
          <img v-if="welcomeEditarTicket1cImg" :src="welcomeEditarTicket1cImg"
            alt="Notificación correo información adicional ticket"
            style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
        </div>

        <div style="text-align:center; margin: 18px 0;">
                      <img v-if="welcomeNuevoTicket1aImg" :src="welcomeNuevoTicket1aImg" alt="Adjuntar archivo paso 1"
              style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
        </div>

<p v-html="$t('manual.welcome.addticketsteps_detalle8')"></p>
         <div style="text-align:center; margin: 18px 0;">
          <img v-if="welcomeEditarTicket1dImg" :src="welcomeEditarTicket1dImg"
            alt="Notificación correo información adicional ticket"
            style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
        </div>
        <div style="text-align:center; margin: 18px 0;">
          <img v-if="welcomeEditarTicket1gImg" :src="welcomeEditarTicket1gImg"
            alt="Notificación correo información adicional ticket"
            style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
        </div>


<p v-html="$t('manual.welcome.addticketsteps_detalle9')"></p>
        <div style="text-align:center; margin: 18px 0;">
          <img v-if="welcomeEditarTicket1eImg" :src="welcomeEditarTicket1eImg"
            alt="Notificación correo información adicional ticket"
            style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
          <div v-else style="color: #c00;">Cargando imagen...</div>
          <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
        </div>
       <div style="text-align:center; margin: 18px 0;">
         <img v-if="welcomeEditarTicket1fImg" :src="welcomeEditarTicket1fImg"
           alt="Notificación correo información adicional ticket"
           style="max-width: 50%; height: auto; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
         <div v-else style="color: #c00;">Cargando imagen...</div>
         <div style="font-size: 0.95em; color: #555; margin-top: 6px;"></div>
       </div>

      </section>
      <!-- 'Verificar' section removed -->
      <!-- Más secciones expandibles -->
    </main>
  </div>
</template>

<script>
import api from '../api';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
 
export default {
  name: 'ManualView',
  data() {
    return {
      section: 'intro',
      accesoInicioSesionImg: null,
      accesoCambioContraseniaImg: null,
      accesoCambioIdiomaImg: null,
      accesoBloqueoUsuarioImg: null,
      welcomeBienvenidaImg: null,
      welcomeNuevoTicketImg: null,
      welcomeNuevoTicket1aImg: null,
      welcomeNuevoTicket1bImg: null,
      welcomeNuevoTicket1cImg: null,
      welcomeCorreoNuevoTicketImg: null,
      welcomeCorreoAsignarUsuarioTicketImg: null,
      welcomeCorreoCerrarTicketImg: null,
      welcomeCorreoReabrirTicketImg: null,
      welcomeCorreoInformacionAdicionalTicketImg: null,
      welcomeNuevoTicketEnListadoImg: null,
      welcomeNuevoTicketDetalle41aImg: null,
      welcomeNuevoTicketDetalle41bImg: null,
      welcomeNuevoTicketDetalle41a2Img: null,
      welcomeEditarTicketEnListadoImg: null,
      welcomeEditarTicket1aImg: null,
      welcomeEditarTicket1bImg: null,
      welcomeEditarTicket1cImg: null,
      welcomeEditarTicket1dImg: null,
      welcomeEditarTicket1eImg: null,
      welcomeEditarTicket1fImg: null,
      welcomeEditarTicket1gImg: null,
    };
  },
  methods: {
    async fetchProtectedImage(filename, dataProp) {
      try {
        if (import.meta.env.DEV) console.log('Solicitando imagen protegida:', filename);
        const resp = await api.get(`/manual-image/${filename}`, { responseType: 'blob' });
        const contentType = resp.headers['content-type'] || resp.headers.get?.('content-type') || '';
        if (!contentType.startsWith('image/')) {
          if (import.meta.env.DEV) {
            console.error('Respuesta no es imagen:', resp);
          }
          throw new Error('La respuesta no es una imagen.');
        }
        this[dataProp] = URL.createObjectURL(resp.data);
        // recalc heights after the image is added to the DOM to keep layout variables up to date
        this.$nextTick(() => {
          try { this.recalcHeaderHeight(); } catch (e) { /* ignore */ }
        });
      } catch (e) {
        if (import.meta.env.DEV) console.error('Error al cargar imagen protegida:', e);
        this[dataProp] = null;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar una imagen del manual.',
          showConfirmButton: false,
          timer: 2000
        });
      }
    },
    verifySwitch() {
      Swal.fire({
        icon: 'success',
        title: 'Verificado',
        text: 'La sección "Verificar" se ha activado correctamente.',
        showConfirmButton: false,
        timer: 1400
      });
    },
    changeSection(name) {
      // force the section change and give a small delay to allow UI updates
      this.section = name;
      // optional visual feedback can be implemented here if needed
    },
    recalcHeaderHeight() {
      // try to find the header container from the DOM and measure its height
      try {
        const header = document.querySelector('.header-container');
        const h = header ? header.getBoundingClientRect().height : 64;
        document.documentElement.style.setProperty('--header-height', `${Math.ceil(h)}px`);
        // also try to measure a footer (if present) so the sidebar doesn't overlap it
        const footer = document.querySelector('footer.app-footer, footer');
        const fh = footer ? footer.getBoundingClientRect().height : 0;
        // use ceil to avoid subpixel layout issues
        document.documentElement.style.setProperty('--footer-height', `${Math.ceil(fh)}px`);
      } catch (e) {
        // ignore
      }
    },
  },
  mounted() {
    // set header height CSS variable and update on resize
    this.recalcHeaderHeight();
    window.addEventListener('resize', this.recalcHeaderHeight);
    this.fetchProtectedImage('acceso_iniciosesion.png', 'accesoInicioSesionImg');
    this.fetchProtectedImage('acceso_cambiocontrasenia.png', 'accesoCambioContraseniaImg');
    this.fetchProtectedImage('acceso_cambioidioma.png', 'accesoCambioIdiomaImg');
    this.fetchProtectedImage('acceso_bloqueousuarioen.png', 'accesoBloqueoUsuarioImg');
    this.fetchProtectedImage('welcome_bienvenida.png', 'welcomeBienvenidaImg');
    this.fetchProtectedImage('welcome_nuevoticket.png', 'welcomeNuevoTicketImg');
    this.fetchProtectedImage('welcome_nuevoticket1a.png', 'welcomeNuevoTicket1aImg');
    this.fetchProtectedImage('welcome_nuevoticket1b.png', 'welcomeNuevoTicket1bImg');
    this.fetchProtectedImage('welcome_nuevoticket1c.png', 'welcomeNuevoTicket1cImg');
    this.fetchProtectedImage('welcome_correonuevoticket.png', 'welcomeCorreoNuevoTicketImg');
    this.fetchProtectedImage('welcome_correoasignarusuarioticket.png', 'welcomeCorreoAsignarUsuarioTicketImg');
    this.fetchProtectedImage('welcome_correocerrarticket.png', 'welcomeCorreoCerrarTicketImg');
    this.fetchProtectedImage('welcome_correoreabrirticket.png', 'welcomeCorreoReabrirTicketImg');
    this.fetchProtectedImage('welcome_correoinformacionadicionalticket.png', 'welcomeCorreoInformacionAdicionalTicketImg');
    this.fetchProtectedImage('welcome_nuevoticketenlistado.png', 'welcomeNuevoTicketEnListadoImg');
    this.fetchProtectedImage('welcome_nuevoticketdetalle41a.png', 'welcomeNuevoTicketDetalle41aImg');
    this.fetchProtectedImage('welcome_nuevoticketdetalle41b.png', 'welcomeNuevoTicketDetalle41bImg');
    this.fetchProtectedImage('welcome_nuevoticketdetalle41a.png', 'welcomeNuevoTicketDetalle41a2Img');
    this.fetchProtectedImage('welcome_editarticketenlistado.png', 'welcomeEditarTicketEnListadoImg');
    this.fetchProtectedImage('welcome_editarticket1a.png', 'welcomeEditarTicket1aImg');
    this.fetchProtectedImage('welcome_editarticket1b.png', 'welcomeEditarTicket1bImg');
    this.fetchProtectedImage('welcome_editarticket1c.png', 'welcomeEditarTicket1cImg');
    this.fetchProtectedImage('welcome_editarticket1d.png', 'welcomeEditarTicket1dImg');
    this.fetchProtectedImage('welcome_editarticket1e.png', 'welcomeEditarTicket1eImg');
    this.fetchProtectedImage('welcome_editarticket1f.png', 'welcomeEditarTicket1fImg');
    this.fetchProtectedImage('welcome_editarticket1g.png', 'welcomeEditarTicket1gImg');
  },
  beforeUnmount() {
    try { window.removeEventListener('resize', this.recalcHeaderHeight); } catch (e) {}
  },
};
</script>

<style scoped>
.manual-table {
  width: 100%;
  border-collapse: collapse;
  margin: 2rem 0 1.5rem 0;
  background: #fafafa;
  font-size: 1em;
}

.manual-table th,
.manual-table td {
  border: 1px solid #ddd;
  padding: 0.75em 1em;
  text-align: left;
}

.manual-table th {
  background: #f0f0f0;
  font-weight: bold;
}

.manual-table a {
  color: #0074d9;
  text-decoration: underline;
}

.manual-container p {
  text-align: justify;
}

.manual-layout {
  display: flex;
  /* fix the manual area to the viewport height minus header and let inner container scroll */
  /* reserve space for header and footer */
  height: calc(100vh - var(--header-height, 64px) - var(--footer-height, 0px));
  background: #f7f7f7;
  overflow: hidden;
}

.manual-sidebar {
  /* Fixed sidebar: stretches from header bottom to viewport bottom */
  position: fixed;
  left: 0;
  top: var(--header-height, 64px);
  /* don't overlap footer: leave space at bottom equal to footer height */
  bottom: var(--footer-height, 0px);
  width: 220px;
  background: #222;
  color: #fff;
  padding: 2rem 1rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* sit above header content but below floating user menus */
  z-index: 120;
  pointer-events: auto;
}

.manual-sidebar nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.manual-sidebar nav ul li {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  transition: background 0.2s;
}

.manual-sidebar nav ul li.active,
.manual-sidebar nav ul li:hover {
  background: #444;
}

.manual-container {
  flex: 1;
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-width: 0;
}

/* make manual content scrollable only inside this container */
.manual-container {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* subtract header and footer and some padding so content scrolls inside without hiding footer */
  max-height: calc(100vh - var(--header-height, 64px) - var(--footer-height, 0px) - 4rem);
}

/* Leave space for the fixed sidebar on wide screens */
@media (min-width: 901px) {
  .manual-container {
    margin-left: calc(220px + 2rem);
    max-width: calc(100% - 220px - 4rem);
  }
  .manual-layout {
    min-height: calc(100vh - var(--header-height, 64px));
  }
}

.manual-container h1 {
  text-align: center;
}

@media (max-width: 900px) {
  .manual-layout {
    flex-direction: column;
  }

  .manual-sidebar {
    width: 100%;
    height: auto;
    min-height: unset;
    position: static;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 1rem 0;
  }

  .manual-sidebar nav ul {
    display: flex;
    flex-direction: row;
    gap: 1rem;
  }

  .manual-sidebar nav ul li {
    margin-bottom: 0;
  }

  .manual-container {
    margin: 1rem;
    padding: 1rem;
    max-height: calc(100vh - var(--header-height, 64px) - var(--footer-height, 0px) - 2rem);
    overflow-y: auto;
  }
}

@media (max-width: 600px) {
  .manual-container {
    padding: 0.5rem;
  }

  .manual-sidebar nav ul li {
    padding: 0.5rem 0.5rem;
    font-size: 0.95em;
  }
}
</style>
